enum EWidget {
  WIDGET_SKIN = "WIDGET_SKIN",
  WIDGET_ACCOUNT = "WIDGET_ACCOUNT ",
}

export default EWidget;
